import { gql } from '@apollo/client'

import { rowsEditFragment } from 'js/page/Page/rowsFragment'

export const GET_PAGE_EDITOR_REVISIONS = gql`
    query PageEditorRevisions(
        $guid: String!
        $offset: Int = 0
        $limit: Int = 50
    ) {
        revisions(containerGuid: $guid, offset: $offset, limit: $limit) {
            total
            edges {
                guid
                description
                timeCreated
                authors {
                    guid
                    name
                }
                type
                statusPublishedChanged
            }
        }
    }
`

export const GET_PAGE_EDITOR_REVISION_CONTENT = gql`
    query PageEditorRevisionContent(
        $guid: String!
        $offset: Int!
        $limit: Int! = 1
    ) {
        revisions(containerGuid: $guid, offset: $offset, limit: $limit) {
            edges {
                guid
                content {
                    rows {
                        ${rowsEditFragment}
                    }
                }
            }
        }
    }
`
